import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Box, Typography } from '@mui/material';
import './BaseCard.scss';

const BaseCard = ({ title, icon, children, className = '', headerActions, hideTitle = false }) => {
  return (
    <Card className={`dashboard-base-card ${className}`}>
      <CardContent>
        {!hideTitle && (
          <Box className="card-header">
            {icon && <Box className="card-icon">{icon}</Box>}
            <Typography variant="h6" className="card-title">
              {title}
            </Typography>
            {headerActions && (
              <Box className="card-header-actions">
                {headerActions}
              </Box>
            )}
          </Box>
        )}

        <Box className="card-body">
          {children}
        </Box>
      </CardContent>
    </Card>
  );
};

BaseCard.propTypes = {
  title: PropTypes.node,
  icon: PropTypes.element,
  children: PropTypes.node,
  className: PropTypes.string,
  headerActions: PropTypes.element,
  hideTitle: PropTypes.bool
};

export default BaseCard;